import { Action } from '@wix/wix-help-widget-common/types';

import { isObject } from '../../util/guards';
import { isRouteValid } from '../routes/utils';
import { NewUrlChangedDuplexerEvent, UrlChangedDuplexerEvent } from './types';

export function isUrlChangedDuplexerEvent(value: unknown): value is UrlChangedDuplexerEvent {
  if (!isObject(value)) {
    return false;
  }

  if (typeof value.id !== 'string') {
    return false;
  }

  const { addedUrl, replacedUrl, removeLast } = value;

  return (
    (typeof addedUrl === 'string' && isRouteValid(addedUrl)) ||
    (typeof replacedUrl === 'string' && isRouteValid(replacedUrl)) ||
    typeof removeLast === 'boolean'
  );
}

export function isNewUrlChangedDuplexerEvent(value: unknown): value is NewUrlChangedDuplexerEvent {
  if (!isObject(value)) {
    return false;
  }

  if (typeof value.tabId !== 'string') {
    return false;
  }

  const { action, url } = value;

  return (
    (action === Action.Push && isRouteValid(url as string)) ||
    (action === Action.Replace && isRouteValid(url as string)) ||
    action === Action.Pop
  );
}

export const getAction = (
  value: UrlChangedDuplexerEvent | NewUrlChangedDuplexerEvent,
): NewUrlChangedDuplexerEvent => {
  if (getDuplexerEvent(value)) {
    return value;
  }
  if (value.addedUrl) {
    return { action: Action.Push, url: value.addedUrl, tabId: value.id };
  }
  if (value.replacedUrl) {
    return { action: Action.Replace, url: value.replacedUrl, tabId: value.id };
  }
  return { action: Action.Pop, tabId: value.id };
};

const getDuplexerEvent = (
  event: UrlChangedDuplexerEvent | NewUrlChangedDuplexerEvent,
): event is NewUrlChangedDuplexerEvent => {
  return 'tabId' in event;
};
